import MHLSalesComponent from "../Components/MHLSales/MHLSalesComponent"

function MHLSalesPage() {
    return (
        <MHLSalesComponent/>
    )
}

export default MHLSalesPage